import { getTexts } from '../imports'
import userStrings from './user.json'
import userListStrings from './user-list.json'
import launchStrings from './launcher.json'

export default locale => ({
    ...getTexts(userStrings)[locale],
    ...getTexts(userListStrings)[locale],
    ...getTexts(launchStrings)[locale],
})



// WEBPACK FOOTER //
// ./src/features/Users/localization/index.js